import { EventEmitterInterface } from 'pf-frontend-common/dist/module/event/emitter.interface';

import { PropertyModel } from 'common/data/property/model';
import { DataStore } from 'common/module/data/store';
import { PropertyCtaStatechartActionEnum } from 'common/module/property-cta/statechart/action.enum';
import { PropertyCtaStatechartPayloadInterface } from 'common/module/property-cta/statechart/payload.interface';
import { StatechartStoreInterface } from 'common/module/statechart/store.interface';
import { PropertyCallTooltipView } from 'desktop/module/property/call-tooltip/view';
import { PropertyLeadPhoneStoreStateInterface } from 'desktop/module/property-lead-phone/store-state.interface';
export class PropertyLeadPhoneStore extends DataStore {
  /**
   * @inheritdoc
   */
  protected state: PropertyLeadPhoneStoreStateInterface;

  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private propertyCtaStatechartStore: StatechartStoreInterface,
    private propertyCallTooltip: PropertyCallTooltipView
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritdoc
   */
  public getState(): PropertyLeadPhoneStoreStateInterface {
    return this.state;
  }

  /**
   * @inheritdoc
   */
  public initialize(): void {
    this.state = {
      visiblePhoneNumbers: {},
    };

    this.propertyCtaStatechartStore
      .getEventEmitter()
      .addListener(
        PropertyCtaStatechartActionEnum.openPhoneLeadPopup,
        this.onOpenPhoneLeadOrAgentInfoPopupActionStatechart
      );

    this.propertyCtaStatechartStore
      .getEventEmitter()
      .addListener(
        PropertyCtaStatechartActionEnum.openAgentInfoPopup,
        this.onOpenPhoneLeadOrAgentInfoPopupActionStatechart
      );
  }

  /**
   * Toggle phone numbers visibility
   */
  public togglePhoneNumbersVisibility(propertyId: string, isVisible: boolean): void {
    this.state.visiblePhoneNumbers[propertyId] = isVisible;
    this.setState(this.state);
  }

  /**
   * Reset phone numbers visibility
   */
  public resetPhoneNumbersVisibility(): void {
    this.state.visiblePhoneNumbers = {};
    this.setState(this.state);
  }

  /**
   * Open call tooltip
   */
  public openCallTooltip(model: PropertyModel, element: HTMLElement): void {
    this.propertyCallTooltip.initialize({
      model,
      element,
    });
    this.propertyCallTooltip.open();
  }

  /**
   * Handle open phone lead popup action
   */
  private onOpenPhoneLeadOrAgentInfoPopupActionStatechart = (payload: PropertyCtaStatechartPayloadInterface) => {
    this.togglePhoneNumbersVisibility(payload.propertyModel.id, true);

    if (!payload.event) {
      return;
    }

    this.openCallTooltip(payload.propertyModel, <HTMLElement>payload.event.currentTarget);
  };
}
